export default __webpack_public_path__ + "images/16dd72e18646157becfdda7b7d26ae0d-hobbies.jpg";